import React, { useEffect, useState } from 'react';

import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';

import {
  useGetAssigmentByIdQuery,
  TeacherAssignmentTypeEnum,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {
  getAllStudents,
  selectedStudentsBaseSelection,
  unSelectStudents,
  liveClassStudentsState,
} from 'redux/liveClass/students.slices';
import useRouterHelper from 'hooks/useRouterHelper';
import { IModel } from 'utils/IStudy';
import Card from 'components/Card/Card';

import IStudyQuery from '../IURLQuery';
import Task from '../Forms/Task';
import Material from '../Forms/Material';
import SearchMaterials from './components/SearchMaterials/SearchMaterials';

import './StudyEdit.scoped.scss';

const StudyTeacherEdit: React.FC = () => {
  const { query } = useRouterHelper<IStudyQuery>();

  const [model, setModel] = useState<IModel>({
    description: '',
    due_at: DateTime.now().toISO(),
    duration: 45,
    id: '',
    teaching_structure_id: query && (query.chapter as string),
    title: '',
    // @ts-ignore
    type: '',
  });
  const { selectedStudents } = useAppSelector(liveClassStudentsState);

  const dispatch = useAppDispatch();

  const { data, loading } = useGetAssigmentByIdQuery({
    variables: {
      _eq: query.item as string, // value for '_eq'
    },
  });

  const history = useHistory();

  const cancel = () => {
    setModel({
      ...model,
      chat_id: null,
      type: TeacherAssignmentTypeEnum.TASK,
    });

    selectedStudents.length > 0 && dispatch(unSelectStudents());
    history.push(
      `/study/details/${query.subject}?title=${query.title}&class=${query.class as string}`
    );
  };

  useEffect(() => {
    dispatch(getAllStudents(query.class as string));

    dispatch(selectedStudentsBaseSelection([]));

    const fetchData = async () => {
      if (!query?.item || loading) {
        return;
      }

      setModel({
        ...model,
        description: data.assignments[0].description,
      });
      setModel({
        id: query?.item.toString(),
        due_at: DateTime.now().toISO(),
        type: data.assignments[0].type,
        title: data.assignments[0].title,
        description: data.assignments[0].description,
        teaching_structure_id: data.assignments[0].teaching_structure_id,
        duration: data.assignments[0].duration,
      });

      dispatch(
        selectedStudentsBaseSelection(
          data.assignments[0].assignment_users.map(obj => {
            return obj.user.id;
          })
        )
      );
    };
    fetchData();
  }, [loading]);

  return (
    <div className="container">
      <div className="edit-area">
        <Card>
          <Card.Body>
            {(function () {
              if (!query) {
                return <></>;
              }
              switch (query.type.toString().toLowerCase()) {
                case 'material':
                  return (
                    <Material
                      subject={query.subject}
                      data={model}
                      assignmentFiles={data?.assignments[0].files}
                      title={query.title as string}
                    />
                  );
                case 'task':
                  return (
                    <Task
                      subject={query.subject as string}
                      data={model}
                      title={query.title as string}
                      assignmentFiles={data?.assignments[0].files}
                      onCancel={cancel}
                      onSave={(subject, assignmentId, title) => {
                        history.push(
                          `/study/details/${subject}?lesson=${assignmentId}&title=${title}&type=TASK&class=${
                            query.class as string
                          }`
                        );
                      }}
                    />
                  );
                default:
                  return <></>;
              }
            })()}
          </Card.Body>
        </Card>
      </div>
      <div className="material-search">
        <SearchMaterials />
      </div>
    </div>
  );
};

export default StudyTeacherEdit;
